import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  petty_cashes: [],
};

const getters = {
  allPettyCashes: (state) => state.petty_cashes,
};

const actions = {
  async fetchPettyCashes({ commit }, params = {}) {
    try {
      commit("resetPettyCashes");
      const response = await axios.get("/petty-cash", { params: prm(params) });
      commit("setPettyCashes", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch petty cashes:", error);
    }
  },
  async createPettyCash({ commit }, petty_cash) {
    try {
      const response = await axios.post("/petty-cash", petty_cash);
      commit("addPettyCash", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create petty cash:", error);
      throw error;
    }
  },
  async fetchPettyCashById(_, id) {
    try {
      const response = await axios.get(`/petty-cash/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch petty cash:", error);
      throw error;
    }
  },
  async updatePettyCash({ commit }, petty_cash) {
    try {
      const response = await axios.put(`/petty-cash/${petty_cash.id}`, petty_cash);
      commit("updatePettyCash", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update petty cash:", error);
      throw error;
    }
  },
  async updatePettyCashStatus({ commit }, { petty_cash, newStatus }) {
    try {
      const updatedPettyCash = {
        ...petty_cash,
        is_active: newStatus
      };
      const response = await axios.put(`/petty-cash/${petty_cash.id}`, updatedPettyCash);
      commit("updatePettyCash", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update petty cash status:", error);
      throw error;
    }
  },
  async deletePettyCashById({ commit }, id) {
    try {
      const response = await axios.delete(`/petty-cash/${id}`);
      commit("removePettyCash", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete petty cash:", error);
      throw error;
    }
  },
};

const mutations = {
  setPettyCashes(state, petty_cashes) {
    state.petty_cashes = petty_cashes.data; // Ensure this matches your API's response structure
  },
  addPettyCash(state, petty_cash) {
    state.petty_cashes.push(petty_cash);
  },
  updatePettyCash(state, updatedPettyCash) {
    const index = state.petty_cashes.findIndex(
      (item) => item.id === updatedPettyCash.id
    );
    if (index !== -1) {
      state.petty_cashes.splice(index, 1, updatedPettyCash);
    }
  },
  removePettyCash(state, id) {
    state.petty_cashes = state.petty_cashes.filter(
      (item) => item.id !== id
    );
  },
  resetPettyCashes(state) {
    state.petty_cashes = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
